import API from "../../api/apiAdmin";

export const AdminContactServices = {
    /**
     * Fetch all contact messages with pagination and optional status filter.
     * @param {number} page
     * @param {number} per_page
     * @param {string} status - unread | read | replied
     */
    getContacts: async (page = 1, per_page = 20, status = '') => {
        try {
            const endpoint = `/admin/contacts/?page=${page}&per_page=${per_page}${status ? `&status=${status}` : ''}`;
            const response = await API.get(endpoint);
            return response.data;
        } catch (error) {
            throw error;
        }
    },

    /**
     * Fetch contact message details with replies.
     * @param {string} messageId
     */
    getContactDetails: async (messageId) => {
        try {
            const response = await API.get(`/admin/contacts/${messageId}`);
            return response.data;
        } catch (error) {
            throw error;
        }
    },

    /**
     * Send a reply to a contact message.
     * @param {string} messageId
     * @param {string} content
     */
    replyToContact: async (messageId, content) => {
        try {
            const response = await API.post(`/admin/contacts/${messageId}/reply`, { content });
            return response.data;
        } catch (error) {
            throw error;
        }
    }
};
